import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DaytranService } from 'src/providers/daytran-ervice/daytran.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-request-by',
  templateUrl: './request-by.component.html',
  styleUrls: ['./request-by.component.scss']
})
export class RequestByComponent implements OnInit {
  @Input() public log;
  requestLog;
  requestBy = '';
  constructor(
    public activeModal: NgbActiveModal,
    private daytranService: DaytranService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.requestLog = this.log;
  }

  async validate(): Promise<void> {
    if (this.requestBy === '') {
      this.toastr.error('Please fill all fields');

      return;
    }
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async position => {
        const body = {
          cancel_requestby: this.requestBy,
          cancel_status: 'PENDING',
          latitude_req: position.coords.latitude,
          longitude_req: position.coords.longitude,
          recid: this.requestLog.recid
        };
        this.spinner.show();
        await this.daytranService.requestCancel(body).then(next => {
          if (next.success === 1) {
            this.toastr.success(next.message);
          } else {
            this.toastr.error(next.message);
          }
        });
        await this.spinner.hide();
        await this.activeModal.close();
      });
    }
  }

  close() {
    this.activeModal.close();
  }

}
